module.exports = __webpack_public_path__ + "static/media/accept.0ed3d522.png";